var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, PacemEventTarget, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
//namespace Pacem.Components.Media {
const DEFAULT_FPS = 25;
const DEFAULT_MIMETYPE = "video/mp4";
const DEFAULT_AUDIO_BITS_PER_SEC = 128000;
const DEFAULT_VIDEO_BITS_PER_SEC = 2500000;
const MEDIA_RECORDER_EVENTS = ["start", "stop", "dataavailable", "pause", "resume", "error", "warning"];
function isStream(obj) {
    if (obj instanceof HTMLCanvasElement) {
        return true;
    }
    return 'captureStream' in obj && typeof obj['captureStream'] === 'function';
}
let PacemMediaRecorderElement = class PacemMediaRecorderElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._recorderLifecycleHandler = (evt) => {
            this.state = this.#recorder.state;
            switch (evt.type) {
                case 'start':
                    this.output = null;
                    break;
                case 'stop':
                    this.flush();
                    break;
                case 'dataavailable':
                    var evtb = evt;
                    this.#chunks.push(evtb.data);
                    break;
            }
        };
        this.#recorder = null;
        this.#chunks = [];
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setupMediaRecorder();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'source':
                case 'fps':
                case 'mimeType':
                case 'audioBitsPerSecond':
                case 'videoBitsPerSecond':
                    this._setupMediaRecorder();
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._closeMediaRecorder();
        super.disconnectedCallback();
    }
    #recorder;
    #chunks;
    _setupMediaRecorder(stream = this.source, options = {
        mimeType: this.mimeType || DEFAULT_MIMETYPE,
        audioBitsPerSecond: this.audioBitsPerSecond ?? DEFAULT_AUDIO_BITS_PER_SEC,
        videoBitsPerSecond: this.videoBitsPerSecond ?? DEFAULT_VIDEO_BITS_PER_SEC
    }) {
        this._closeMediaRecorder();
        if (!Utils.isNull(stream)) {
            if (isStream(stream)) {
                const fps = this.fps || DEFAULT_FPS;
                stream = stream.captureStream(fps);
            }
            try {
                this.#recorder = new MediaRecorder(stream, options);
            }
            catch (e) {
                console.error(e);
            }
            const r = this.#recorder;
            MEDIA_RECORDER_EVENTS.forEach(e => {
                r.addEventListener(e, this._recorderLifecycleHandler, false);
            });
        }
    }
    _closeMediaRecorder() {
        const r = this.#recorder;
        if (!Utils.isNull(r)) {
            if (r.state !== 'inactive') {
                r.stop();
            }
            MEDIA_RECORDER_EVENTS.forEach(e => {
                r.removeEventListener(e, this._recorderLifecycleHandler, false);
            });
            this.#recorder = null;
        }
    }
    flush() {
        const blob = new Blob(this.#chunks, { 'type': this.mimeType || DEFAULT_MIMETYPE });
        this.#chunks = [];
        this.output = blob;
    }
    start() {
        const r = this.#recorder;
        if (!Utils.isNull(r) && r.state === 'inactive') {
            r.start();
        }
    }
    stop() {
        const r = this.#recorder;
        if (!Utils.isNull(r) && r.state !== 'inactive') {
            r.stop();
        }
    }
    resume() {
        const r = this.#recorder;
        if (!Utils.isNull(r) && r.state === 'paused') {
            r.start();
        }
    }
    pause() {
        const r = this.#recorder;
        if (!Utils.isNull(r) && r.state !== 'paused') {
            r.pause();
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemMediaRecorderElement.prototype, "source", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMediaRecorderElement.prototype, "fps", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMediaRecorderElement.prototype, "mimeType", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMediaRecorderElement.prototype, "audioBitsPerSecond", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMediaRecorderElement.prototype, "videoBitsPerSecond", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemMediaRecorderElement.prototype, "state", void 0);
__decorate([
    Watch()
], PacemMediaRecorderElement.prototype, "output", void 0);
PacemMediaRecorderElement = __decorate([
    CustomElement({ tagName: P + '-media-recorder' })
], PacemMediaRecorderElement);
export { PacemMediaRecorderElement };
